import { render, staticRenderFns } from "./LeadEventRecommendation.vue?vue&type=template&id=a762989c&"
import script from "./LeadEventRecommendation.vue?vue&type=script&lang=js&"
export * from "./LeadEventRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./LeadEventRecommendation.vue?vue&type=style&index=0&id=a762989c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports